<template>
  <svg class="sat-icon" :width="size" :height="size" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path v-for="(d, index) in paths" :key="index" :d="d" />
  </svg>
</template>
<script>
// Stroke icons of the satellite pages (24x24 grid, currentColor), so they follow the text color in both themes.
const ICONS = {
  link: ["M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71", "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"],
  copy: ["M20 9h-9a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2z", "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"],
  check: ["M20 6 9 17l-5-5"],
  plus: ["M12 5v14", "M5 12h14"],
  trash: ["M3 6h18", "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6", "M10 11v6", "M14 11v6", "M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"],
  chevron: ["m6 9 6 6 6-6"],
  "chevron-right": ["m9 18 6-6-6-6"],
  back: ["M19 12H5", "m12 19-7-7 7-7"],
  alert: ["M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z", "M12 9v4", "M12 17h.01"],
  info: ["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z", "M12 16v-4", "M12 8h.01"],
  x: ["M18 6 6 18", "m6 6 12 12"],
  server: ["M20 2H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z", "M20 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2z", "M6 6h.01", "M6 18h.01"],
  globe: ["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z", "M2 12h20", "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"],
  route: ["M6 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", "M18 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", "M9 16h5.5a3.5 3.5 0 0 0 0-7H9.5a3.5 3.5 0 0 1 0-7H18"],
  layers: ["m12 2 10 5-10 5L2 7l10-5z", "m2 17 10 5 10-5", "m2 12 10 5 10-5"],
  grid: ["M10 3H3v7h7z", "M21 3h-7v7h7z", "M21 14h-7v7h7z", "M10 14H3v7h7z"],
  file: ["M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z", "M14 2v6h6"],
  external: ["M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", "M15 3h6v6", "M10 14 21 3"],
  search: ["M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z", "m21 21-4.35-4.35"],
  lock: ["M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2z", "M7 11V7a5 5 0 0 1 10 0v4"],
  edit: ["M12 20h9", "M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"],
  refresh: ["M23 4v6h-6", "M1 20v-6h6", "M3.51 9a9 9 0 0 1 14.85-3.36L23 10", "M1 14l4.64 4.36A9 9 0 0 0 20.49 15"],
  "arrow-up-circle": ["M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z", "m16 12-4-4-4 4", "M12 16V8"],
  sliders: ["M4 21v-7", "M4 10V3", "M12 21v-9", "M12 8V3", "M20 21v-5", "M20 12V3", "M1 14h6", "M9 8h6", "M17 16h6"],
  bell: ["M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9", "M13.73 21a2 2 0 0 1-3.46 0"],
  shuffle: ["M16 3h5v5", "M4 20 21 3", "M21 16v5h-5", "m15 15 6 6", "M4 4l5 5"],
  send: ["m22 2-11 11", "M22 2 15 22l-4-9-9-4z"],
  code: ["m16 18 6-6-6-6", "m8 6-6 6 6 6"],
  chart: ["M18 20V10", "M12 20V4", "M6 20v-6"],
};

export default {
  name: "SatIcon",
  props: {
    name: {
      type: String,
      required: true,
      validator: (value) => value in ICONS,
    },
    size: {
      type: [Number, String],
      default: 16,
    },
  },
  computed: {
    paths() {
      return ICONS[this.name];
    },
  },
};
</script>
<style lang="scss" scoped>
.sat-icon {
  flex-shrink: 0;
  vertical-align: middle;
}

// Global styles fill svg icons of buttons and links: these are stroke icons.
.sat-icon,
.sat-icon path {
  fill: none !important;
  stroke: currentColor !important;
}
</style>
